module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Italic.a8f3eab.ttf";